/**
 * Created by jpilz on 2/13/17.
 * https://bootsnipp.com/snippets/a3BjR
 */
import 'es6-shim';
import 'babel-polyfill';
import $ from 'jquery';
import ko from 'knockout';
//import * as d3 from 'd3';
//import Chart from 'chart.js';
import 'knockout.validation';
import 'knockout-mapping';
import 'bootstrap';
import 'froala-editor';
import 'axios';
import 'animate.css';
import './bindings/knockout.animate';
//import './bindings/knockout.chart';

//Sentry/Raven
import 'jquery.scrollintoview';


//Decrypt
//import base64js from 'base64-js';
//import mcrypt from 'js-rijndael';
//import CryptoJS from 'crypto-js';

//code Mirror;
import 'code-mirror';
import enableCM from 'knockout-code-mirror';
import 'code-mirror/mode/css';
import 'code-mirror/mode/javascript';
import 'code-mirror/addon/hint/show-hint';
import 'code-mirror/addon/hint/show-hint.css';
import 'code-mirror/addon/hint/css-hint';
import 'code-mirror/theme/base16-light';
import 'code-mirror/theme/base16-light.css';
import 'code-mirror/codemirror.css';

//Knockout Froala
import 'knockout-froala';


//Plugins 
import 'froala-editor/js/plugins/align.min';
import 'froala-editor/js/plugins/char_counter.min';
import 'froala-editor/js/plugins/code_beautifier.min';
import 'froala-editor/js/plugins/code_view.min';
import 'froala-editor/js/plugins/colors.min';
import 'froala-editor/js/plugins/draggable.min';
import 'froala-editor/js/plugins/entities.min';
import 'froala-editor/js/plugins/font_family.min';
import 'froala-editor/js/plugins/font_size.min';
import 'froala-editor/js/plugins/forms.min';
import 'froala-editor/js/plugins/fullscreen.min';
import 'froala-editor/js/plugins/help.min';

import 'froala-editor/js/plugins/inline_style.min';

import 'froala-editor/js/plugins/paragraph_style.min';
import 'froala-editor/js/plugins/paragraph_format.min';
import 'froala-editor/js/plugins/print.min';

import 'froala-editor/js/plugins/quick_insert.min';

import 'froala-editor/js/plugins/save.min';
import 'froala-editor/js/plugins/special_characters.min';

import 'froala-editor/js/plugins/table.min';

import 'froala-editor/js/plugins/url.min';

import 'froala-editor/js/plugins/word_paste.min';


import 'font-awesome/css/font-awesome.css';

import 'froala-editor/css/plugins/colors.min.css';
import 'froala-editor/css/plugins/code_view.min.css';
import 'froala-editor/css/plugins/draggable.min.css';
import 'froala-editor/css/plugins/fullscreen.min.css';

import 'froala-editor/css/plugins/help.min.css';
import 'froala-editor/css/plugins/quick_insert.min.css';
import 'froala-editor/css/plugins/special_characters.min.css';
import 'froala-editor/css/plugins/table.min.css';


import 'froala-editor/css/froala_editor.css';
import 'froala-editor/css/froala_style.css';

// Css Imports
import 'bootstrap/dist/css/bootstrap.css';
import './css/style.css';
import './css/timeline.css';
import './css/chart.css';
import './css/appUI.css';

//Dialogs
import 'bootstrap3-dialog/dist/css/bootstrap-dialog.css';

ko.components.register('editor-stylesheet', require('./components/editorStyleSheet/editorStyleSheet').default);

ko.components.register('app-header', require('./components/header/header').default);
ko.components.register('app-workspace', require('./components/workspace/workspace').default);
ko.components.register('app-footer', require('./components/footer/footer').default);
ko.components.register('review-editor', require('./components/review/review-editor/review-editor').default);

//Tabs
//ko.components.register('tab-general', require('./components/tabGeneral/tabGeneral').default);
ko.components.register('tab-review-approve', require('./components/review/tabReviewApprove/tabReviewApprove').default);
ko.components.register('tab-editor', require('./components/nav-job-list/tabEditor/tabEditor').default);
ko.components.register('job-history', require('./components/nav-job-list/job-history/job-history').default);

//Item Components
ko.components.register('review-item', require('./components/review/review-item/review-item').default);

ko.components.register('job-template', require('./components/jobDefaultTemplate/jobDefaultTemplate').default);

//Dynamic Components
ko.components.register('job-edit', require('./components/job-edit/job-edit').default);

//Options Components
ko.components.register('custom-options-inline', require('./components/options/customOptionsInline/customOptionsInline').default);
ko.components.register('editor-style-editor', require('./components/options/editorStylesEditor/editorStylesEditor').default);
ko.components.register('custom-options-report', require('./components/options/customReport/customReport').default);
//ko.components.register('reports-to-editor', require('./components/options/reportsToEditor/reportsToEditor').default);
//ko.components.register('department-editor', require('./components/options/departmentEditor/departmentEditor').default);
//ko.components.register('created-by-editor', require('./components/options/createdByEditor/createdByEditor').default);
ko.components.register('internal-users', require('./components/options/internal-users/internal-users').default);

//Modals
//ko.components.register('summary-modal', require('./components/summary-modal/summary-modal').default);
ko.components.register('boot-modal', require('./components/boot-modal/boot-modal').default);
ko.components.register('jdm-modal', require('./components/job-create/jdm-modal').default);
ko.components.register('review-modal', require('./components/review/review-modal/review-modal').default);
ko.components.register('help-modal', require('./components/help-modal/help-modal').default);
ko.components.register('user-modal', require('./components/user/login/login').default);
ko.components.register('save-job-modal', require('./components/nav-job-list/save-job-modal/save-job-modal').default);


ko.options.deferUpdates = true;
ko.virtualElements.allowedBindings.bindHTML = true;

ko.validation.init({insertMessages: true});

ko.validation.rules['nullableInt'] = {
    validator: function (val, validate) {
        return val === null || val === "" || (validate && /^-?\d*$/.test(val.toString()));
    },
    message: 'Must be empty or an integer value'
};

ko.observableGroup = function(observables) {
    var observableManager = {};
    var throttle = 0;
    var throttleTimeout;

    observableManager.throttle = function(duration) {
        throttle = duration;
        return observableManager;
    };

    observableManager.subscribe = function(handler) {
        function throttledHandler(val) {
            if(throttle > 0) {
                if(!throttleTimeout) {
                    throttleTimeout = setTimeout(function() {
                        throttleTimeout = undefined;
                        handler(val);
                    }, throttle);
                }
            }
            else
            { handler(val); }
        }

        for(var i = 0; i < observables.length; i++)
        { observables[i].subscribe(throttledHandler); }

        return observableManager;
    };

    return observableManager;
};

var getType = function(obj) {
    if ((obj) && (typeof (obj) === "object") && (obj.constructor == (new Date).constructor)) return "date";
    return typeof obj;
};

var getSubscribables = function(model) {
    var subscribables = [];
    scanForObservablesIn(model, subscribables);
    return subscribables;
};

var scanForObservablesIn = function(model, subscribables){
    for (var parameter in model)
    {
        var typeOfData = getType(model[parameter]);
        switch(typeOfData)
        {
            case "object": { scanForObservablesIn(model[parameter], subscribables); } break;
            case "array":
            {
                var underlyingArray = model[parameter]();
                underlyingArray.forEach(function(entry, index){ scanForObservablesIn(underlyingArray[index], subscribables); });
            }
            break;

            default:
            {
                if(ko.isComputed(model[parameter]) || ko.isObservable(model[parameter]))
                { subscribables.push(model[parameter]); }
            }
            break;
        }
    }
};

ko.bindingHandlers.chart = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
        var allBindings = allBindingsAccessor();
        var chartBinding = allBindings.chart;
        var activeChart;
        var chartData;

        var createChart = function() {
            var chartType = ko.unwrap(chartBinding.type);
            var data = ko.toJS(chartBinding.data);
            var options = ko.toJS(chartBinding.options);

            chartData = {
                type: chartType,
                data: data,
                options: options
            };

            activeChart = new Chart(element, chartData);
        };

        var refreshChart = function() {
            chartData.data = ko.toJS(chartBinding.data);
            activeChart.update();
            activeChart.resize();
        };

        var subscribeToChanges = function() {
            var throttleAmount = ko.unwrap(chartBinding.options.throttle) || 100;
            var dataSubscribables = getSubscribables(chartBinding.data);
            console.log("app:chart: throttleAmount: %o, dataSubscribables: %o", throttleAmount, dataSubscribables);

            ko.observableGroup(dataSubscribables)

                .subscribe(refreshChart);
        };

        createChart();

        if(chartBinding.options && chartBinding.options.observeChanges)
        {   
            console.log("app:chart: calling: subscribeToChanges");
            subscribeToChanges(); 
        }
    }
};

ko.bindingHandlers.allowBindings = {
    init: function(elem, valueAccessor) {
        // Let bindings proceed as normal *only if* my value is false
        var shouldAllowBindings = ko.unwrap(valueAccessor());
        return { controlsDescendantBindings: !shouldAllowBindings };
    }
};

ko.bindingHandlers.bindHTML = {
    init: function () {
        // we will handle the bindings of any descendants
        return { controlsDescendantBindings: true };
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        // must read the value so it will update on changes to the value
        var value = ko.utils.unwrapObservable(valueAccessor());
        // create the child html using the value
        ko.applyBindingsToNode(element, { html: value });
        // apply bindings on the created html
        ko.applyBindingsToDescendants(bindingContext, element);
    }
};

ko.bindingHandlers.enterkey = {
    init: function (element, valueAccessor, allBindings, viewModel) {
        console.log("app:ko.bindingHandlers.enterkey: init:");
        var callback = valueAccessor();
        $(element).keypress(function (event) {
            var keyCode = (event.which ? event.which : event.keyCode);
            if (keyCode === 13) {
                callback.call(viewModel);
                return false;
            }
            return true;
        });
    },
    update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        console.log("app:ko.bindingHandlers.enterkey: update:");
    }
};


$.fn.extend({
    animateCss: function (animationName) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
        this.addClass('animated ' + animationName).one(animationEnd, function() {
            $(this).removeClass('animated ' + animationName);
        });
        return this;
    }
});

enableCM({
    theme: 'base16-light'
  });


// Protoypes
Array.prototype.sortColumn = 'title';
Array.prototype.sortColumnAsc = 'Desc';

$(document).ready(function(){

    
    ko.applyBindings({});

    $.FroalaEditor.DefineIcon('alert', {NAME: 'info'});
    $.FroalaEditor.RegisterCommand('alert', {
      title: 'Hello',
      focus: false,
      undo: false,
      refreshAfterCallback: false,
      callback: function () {
        alert('Hello!');
      }
    });

    $('[data-toggle="tooltip"]').tooltip();

    console.log("Calling boot modal");
    $('#summaryModal').modal('show');
   


/*
    $('div#froala-editor').froalaEditor({
      pluginsEnabled: ['codeView','wordPaste', 'customPlugin'],
      charCounterCount: true,
      initOnClick: true
      });
*/

});


// WEBPACK FOOTER //
// ./src/app.js